import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TEmbError } from '@monorepo/types';

@Component({
  selector: 'monorepo-emb-failure',
  templateUrl: './emb-failure.component.html',
  styleUrls: ['./emb-failure.component.scss'],
})
export class EmbFailureComponent implements OnInit {
  errors: string[] = [];
  tagIds: string[] = [];
  @Input() errorsObj: TEmbError[] = [];

  constructor(public modal: ModalController) {}
  
  ngOnInit(): void {
    this.errors = this.errorsObj.map((error) => {
      if (error.errorType === 'TOP_LEVEL') return error.errors.join(', ');
      else {
        this.tagIds.push(error.tagId);
        return `TagId(${error.tagId}) errors - ` + error.errors.join(', ');
      }
    });
  }

  onOkClick() {
    this.modal.dismiss(this.tagIds, 'OK');
  }
}
